import { Box, Button, Select, TableCell, styled } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

const commonInputStyle = {
  fontSize: 14,
  fontWeight: 500,
  height: "40px",
  minHeight: "40px",
  borderRadius: "8px",
};

export const LeaderboardPageWrapper = styled(Box)(({ theme }) => ({
  padding: "32px",
  backgroundColor: theme.palette.background.default,
  minHeight: "100vh",
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  backgroundColor: theme.palette.grey[100],
}));

export const CenteredWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(4),
  paddingTop: "2em"
}));

export const ActionModulePickerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  marginBottom: theme.spacing(2),
  minHeight: "56px",
  width: "80%",
  maxWidth: 400,
}));

export const DatePickerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  minHeight: "56px",
  width: "80%",
  maxWidth: 400,
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  width: "100%", 
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  "& .MuiSelect-select": {
    ...commonInputStyle,
    padding: theme.spacing(1.2, 2),
    display: "flex",
    alignItems: "center",
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  height: "40px",
  padding: theme.spacing(0, 3),
  fontWeight: 600,
  fontSize: 14,
  textTransform: "none",
  borderRadius: theme.shape.borderRadius,
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  "& .MuiInputBase-root": {
    ...commonInputStyle,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.divider,
  },
}));